module.exports = __webpack_public_path__ + "static/media/admin_canvas_cuff_icon.d1374b14.svg";